import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLayoutGrid1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconLayoutGrid1"><Path d="M3 3H11V9H3V3Z" fill="currentColor"/><Path d="M13 15H21V21H13V15Z" fill="currentColor"/><Path d="M3 11H11V21H3V11Z" fill="currentColor"/><Path d="M13 3H21V13H13V3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLayoutGrid1;
